export const qS = document.querySelector.bind(document);
export const qSA = document.querySelectorAll.bind(document);
